export const onEnterOrSpace = (event: React.UIEvent, callback: () => void) => {
  if (event instanceof KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      callback();
    }
  }
};

/**
 * Class to manage a stack of Escape key handlers.
 *
 * When the Escape key is pressed, the topmost handler in the stack is invoked.
 */
class EscapeStack {
  private stack: (() => void)[] = [];

  constructor() {
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.stack.length > 0) {
        this.stack[this.stack.length - 1]();
      }
    });
  }

  /**
   * Pushes a new Escape key handler onto the stack.
   *
   * @param {() => void} callback The callback to invoke when Escape is pressed.
   * @return {() => void} A function to remove the callback from the stack.
   */
  push(callback: () => void): () => void {
    this.stack.push(callback);
    return () => {
      this.stack = this.stack.filter(c => c !== callback);
    };
  }
}

/**
 * Singleton instance of EscapeStack for handling Escape key events globally.
 */
export const escapeStack = new EscapeStack();
